/**
 * Executes a dynamic or predefined configuration function with given arguments.
 *
 * @param {any} functionDefinition - Either a function or a string containing JavaScript code to be executed.
 * @param {string} functionName - Name of the function, used for logging or error messages.
 * @param {string} argumentNames - Comma-separated names of arguments to be passed to the function.
 * @param {...any} argumentValues - The values corresponding to the argument names, passed into the function call.
 *
 * @returns {any} - The return value of the executed function, or `undefined` if execution fails.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function callConfigFunction(functionDefinition, functionName, argumentNames, ...argumentValues) {
    let functionBody;
    switch (typeof functionDefinition) {
        case 'function':
            functionBody = functionDefinition;
            break;
        case 'string':
            try {
                functionBody = Function('"use strict"; return (function(' + argumentNames + ') { ' + functionDefinition + '; })')();
            }
            catch (error) {
                console.error('Invalid ' + functionName + ' function', error);
            }
            break;
    }
    if (functionBody) {
        try {
            return functionBody(...argumentValues);
        }
        catch (error) {
            console.error('Error in ' + functionName + ' function', error);
        }
    }
    return undefined;
}
